<template>
  <div class="list">
    <div class="add">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="onAddClick">新建菜单</el-button>
    </div>
    <br />
    <el-table v-loading="listLoading" :data="list" border style="width: 100%">
      <el-table-column prop="menu_name" label="菜单名称" align="center" />
      <el-table-column align="center" prop="menu_url" label="菜单url" />
      <el-table-column align="center" prop="type" label="菜单等级" />
      <el-table-column align="center" prop="f_menu_name" label="上级菜单" />
      <el-table-column align="center" label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="handleEditClick(scope.row)">编辑</el-button>
          <el-button type="danger" size="small" @click="handleDeleteClick(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="page">
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page_index"
        :limit.sync="listQuery.page_size"
        @pagination="getList"
      />
    </div>

    <el-drawer ref="drawer" title="新增/编辑菜单" :visible.sync="showMdal" direction="rtl" custom-class="drawer">
      <div class="drawer-content">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
          <el-form-item label="菜单名称" prop="menu_name"
            ><el-input v-model="form.menu_name" autocomplete="off"
          /></el-form-item>
          <el-form-item label="菜单url" prop="menu_url"
            ><el-input v-model="form.menu_url" autocomplete="off"
          /></el-form-item>
          <el-form-item label="菜单等级" prop="type">
            <el-select v-model="form.type" placeholder="请选择菜单等级" @change="getParentList">
              <el-option label="一级菜单" value="1" />
              <el-option label="二级菜单" value="2" />
              <el-option label="三级菜单" value="3" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="form.type !== '1'" label="上级菜单" prop="fid">
            <el-select v-model="form.fid" placeholder="请选择上级菜单">
              <el-option v-for="(value, key) in parentList" :key="key" :label="value" :value="key + ''" />
            </el-select>
          </el-form-item>
        </el-form>
        <div class="drawer-footer">
          <el-button class="btn" @click="cancelForm">取 消</el-button>
          <el-button class="btn" type="primary" :loading="submitLoading" @click="onSubmitClick">{{
            submitLoading ? "提交中 ..." : "保 存"
          }}</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { getMenuList, getParentMenu, deleteMenu, saveMenu, editMenu } from "@/api/auth";
import Pagination from "@/components/Pagination";
import operations from "../../mixins/operations";

export default {
  components: { Pagination },
  mixins: [operations],

  data() {
    return {
      list: [],
      parentList: {},
      total: 0,
      listQuery: {
        page_index: 1,
        page_size: 10,
      },
      listLoading: false,
      showMdal: false,
      form: {
        menu_name: "",
        menu_url: "",
        fid: "",
        type: "",
      },
      formLabelWidth: "100px",
      submitLoading: false,
      editId: null,
      rules: {
        title: [
          {
            required: true,
            message: "请输入菜单名称",
            trigger: "blur",
          },
          { min: 2, message: "长度在 2个字符以上", trigger: "blur" },
        ],
        url: [
          {
            required: true,
            message: "请输入菜单地址",
            trigger: "blur",
          },
        ],
        level: [{ required: true, message: "请选择等级", trigger: "change" }],
        fid: [
          {
            required: true,
            message: "请选择父级菜单",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    hasAddOperation() {
      return this.operations.includes("新建菜单");
    },
    hasEditOperation() {
      return this.operations.includes("编辑菜单");
    },
    hasDeleteOperation() {
      return this.operations.includes("删除菜单");
    },
  },
  async mounted() {
    this.getList();
  },
  methods: {
    async getList(params = this.listQuery) {
      this.listLoading = true;
      const { total, data } = await getMenuList(params);

      this.listLoading = false;
      this.total = total;
      this.list = data;
    },
    async getParentList(type) {
      if (type === "1") {
        this.parentList = [];
        return false;
      }
      const result = await getParentMenu({ type: +type - 1 });

      this.parentList = result;
    },
    onAddClick() {
      this.showMdal = true;
      this.editId = null;
      this.setDefault();

      if (this.$refs.form) this.$refs.form.resetFields();
    },
    handleEditClick(row) {
      this.setDefault();
      this.showMdal = true;
      if (this.$refs.form) this.$refs.form.resetFields();
      this.editId = row.id;
      const { menu_url, menu_name, fid, type } = row;
      this.getParentList(type);
      this.form = {
        menu_url,
        menu_name,
        fid: fid + "",
        type,
      };
    },
    async handleDeleteClick(id) {
      this.$confirm(`是否删除该菜单？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        await deleteMenu(id).catch((error) => {
          throw error;
        });
        this.$notify({ title: "操作成功", type: "success" });
        this.getList();
      });
    },
    cancelForm() {
      this.showMdal = false;
    },
    onSubmitClick() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.submitLoading = true;
          const id = this.editId;
          const data = { ...this.form };
          if (!id) {
            await saveMenu(data).catch((error) => {
              this.submitLoading = false;
              throw error;
            });
          } else {
            data.id = id;
            await editMenu(id, data).catch((error) => {
              this.submitLoading = false;
              throw error;
            });
          }

          this.$notify({ title: "操作成功", type: "success" });
          this.getList();
          this.editId = null;
          this.submitLoading = false;
          this.$refs.form.resetFields();
          this.$refs.drawer.closeDrawer();
        }
      });
    },
    setDefault() {
      this.form = { menu_name: "", menu_url: "", fid: "", type: "" };
    },
  },
};
</script>

<style lang="less" scoped>
.drawer-content {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;

  .drawer-footer {
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    .btn {
      width: 50%;
    }
  }
  .el-select {
    width: 100%;
  }
}
</style>
